import { createReducer, on, Action } from '@ngrx/store';
import update from 'immutability-helper';

import * as ModalPanelActions from 'render/render-shared/ui/render-modal-panel/store/render-modal-panel.actions';
import { ModalPanelState } from 'render/render-shared/ui/render-modal-panel/store/render-modal-panel.state';


export const initialState: ModalPanelState = {
  modalsStack: []
};

const reducer = createReducer(
  initialState,
  on(ModalPanelActions.openModal, (state, { modalName, props }) => update(state, {
    modalsStack: {
      $push: [{ modalName, props }]
    }
  })),
  on(ModalPanelActions.closeModal, (state, { modalName }) => {
    const index = state.modalsStack.findIndex((modal) => modal.modalName === modalName);
    return index === -1 ? state : update(state, {
      modalsStack: {
        $splice: [[index, 1]]
      }
    });
  }),
  on(ModalPanelActions.closeAllModals, (state) => update(state, {
    modalsStack: {
      $set: []
    }
  }))
);

export function renderModalPanelReducer(state: ModalPanelState, action: Action): ModalPanelState {
  return reducer(state, action);
}
